import type { ThunkAction } from '../../types/app.types';
import { trackClick } from '../../utils/analytics';
export type ModalState = {
  openModalName: string;
};
export type Open = {
  type: 'modal/OPEN';
  name: string;
};
export type Close = {
  type: 'modal/CLOSE';
};
export type ModalAction = Open | Close;
const initialState: ModalState = {
  openModalName: '',
};
export function openModal(name: string): ThunkAction<Open> {
  return function (dispatch): Open {
    dispatch(trackClick(name, 'modal'));
    return dispatch({
      type: 'modal/OPEN',
      name,
    });
  };
}
export function closeModal(): Close {
  return {
    type: 'modal/CLOSE',
  };
}
export default function modalReducer(state: ModalState = initialState, action: ModalAction): ModalState {
  switch (action.type) {
    case 'modal/OPEN':
      return {
        openModalName: action.name,
      };

    case 'modal/CLOSE':
      return {
        openModalName: '',
      };

    default:
      return state;
  }
}
